import { useState } from "react";
import { useApi, PageHeader, Loading, Select, Pager, TableWrap, Empty } from "../components/common";
import { fdatetime } from "../lib/format";

const ENTITIES = ["invoice", "payment", "expense", "lead", "client", "project", "task", "user", "settings", "file", "quotation", "system"];

export default function AuditLog() {
  const [entity, setEntity] = useState("");
  const [page, setPage] = useState(1);
  const { data, loading } = useApi(`/audit-logs?entity=${entity}&page=${page}`);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Every sensitive change, who made it and when" actions={<Select testid="audit-filter-entity" className="w-44" placeholder="All records" options={ENTITIES} value={entity} onChange={(v) => { setEntity(v); setPage(1); }} />} />
      <TableWrap>
        {loading && !data ? <Loading /> : !data?.items.length ? <Empty /> : (
          <table className="vmw-table" data-testid="audit-table">
            <thead><tr><th>When</th><th>User</th><th>Action</th><th>Record</th><th>Details</th></tr></thead>
            <tbody>{data.items.map((a) => (
              <tr key={a.id}><td className="text-xs whitespace-nowrap">{fdatetime(a.at)}</td><td>{a.user_name} <span className="text-[10px] text-muted-foreground">{a.role}</span></td>
                <td className="font-semibold">{a.action}</td><td className="text-xs">{a.entity}</td><td className="text-[11px] text-muted-foreground max-w-md break-all">{JSON.stringify(a.details)}</td></tr>))}</tbody>
          </table>)}
        {data && <Pager page={page} total={data.total} pageSize={50} onPage={setPage} />}
      </TableWrap>
    </div>
  );
}
